var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6296 12.3842L13.2447 0.500244H16.5645L16.1796 12.3842H13.6296ZM14.9046 18.4946C13.7258 18.4946 12.6914 17.7248 12.6914 16.3777C12.6914 15.0305 13.7258 14.2847 14.9046 14.2847C16.0593 14.2847 17.1178 15.0305 17.1178 16.3777C17.1178 17.7248 16.0593 18.4946 14.9046 18.4946Z",
    fill: "#1BE1F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4342 1.18384C9.90719 1.18384 11.7904 3.09153 11.7904 5.41501C11.7904 9.27931 7.11902 9.20594 7.11902 12.2876H4.55097C4.55097 7.9586 8.39081 8.4233 8.39081 5.97753C8.39081 4.73019 7.55926 4.06984 6.04288 4.06984C4.72217 4.06984 3.01014 4.63236 1.95846 5.58621L0.882324 2.9937C2.12966 2.13769 3.98844 1.18384 6.4342 1.18384ZM5.84722 18.4998C7.04565 18.4998 8.12178 17.7172 8.12178 16.3476C8.12178 14.9779 7.04565 14.2197 5.84722 14.2197C4.6488 14.2197 3.59712 14.9779 3.59712 16.3476C3.59712 17.7172 4.6488 18.4998 5.84722 18.4998Z",
    fill: "#1BE1F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.a735480339e8c7f7c562a0035ea3328a.svg";
export { ForwardRef as ReactComponent };